module.exports = __webpack_public_path__ + "img/cases-brand-chinamobile-lazyload-21.35182562.jpg";